'use strict';


import React from 'react';
import PropTypes from 'prop-types';

//
import Component from '../core/component';
import Enhance from '../core/enhance';

//

class Link extends Component {
    state = {}


    constructor() {
        super();
    }

    componentDidMount() {
    }

    render() {
        return (
            <a
                href="javascript:;"
                className={this.props.className}
                onClick={this._handlerLinkClick}
            >
                {this.props.children}
            </a>
        )
    }

    _handlerLinkClick(e) {
        this.props.onClick && this.props.onClick(e);
        this.props.href && pushState(this.props.href);
    }

}
Enhance(Link, {
    propTypes: {
        href: PropTypes.string,
        onClick: PropTypes.func,
    }
}, 'Link');

export default Link;